import { Link } from "react-router-dom";

export const Logo = ({ className = "", src = "/wisp-mark.png", imgClassName = "h-12 w-auto" }) => (
  <Link to="/" data-testid="logo-link" className={`inline-flex items-center ${className}`}>
    <img
      src={src}
      alt="Wisp Home Cleaning — Clean home. Happy you."
      className={`${imgClassName} transition-transform duration-300 hover:scale-[1.03]`}
    />
  </Link>
);
